export default __webpack_public_path__ + "static/media/Blooded Gloves of the Seven Suns.0de96507.jpg";